import { Button, Card, Table, Select, Modal, Empty } from "antd";
import type { ComponentProps } from "react";
import type { TableProps } from "antd";
export { Tag, type TagProps } from "./Tag";
export const CustomButton = (p: ComponentProps<typeof Button>) => <Button {...p} />;
export const CustomCard = (p: ComponentProps<typeof Card>) => <Card {...p} />;
export function CustomTable<T extends object = Record<string, unknown>>(p: TableProps<T>) { return <Table<T> {...p} />; }
export const CustomSelect = (p: ComponentProps<typeof Select>) => <Select {...p} />;
export const SelectOption = Select.Option;
export const CustomModal = (p: ComponentProps<typeof Modal>) => <Modal {...p} />;
export const CustomEmptyState = (p: ComponentProps<typeof Empty>) => <Empty {...p} />;
